import { DeviceEvent } from 'src/models';
import { compareString } from 'src/helper';

export type GetDeviceEventsQueryParams = {
  eventType: string;
  start: string;
  end: string;
  humanId?: string;
  phyDeviceId?: string;
  companies?: string;
};

export type GetDeviceEventsResponse = DeviceEvent[];

export const sortDeviceEvents = (events: DeviceEvent[]) => {
  if (events.length === 0) {
    return events;
  }

  const dateMap = [...events]
    .sort((a, b) => compareString(a.date, b.date))
    .reduce(
      (map, current) => ({
        ...map,
        [current.date]: [...(map[current.date] ?? []), current],
      }),
      {} as Record<string, DeviceEvent[]>,
    );

  let lastValue: string | null = null;

  return Object.keys(dateMap)
    .sort((a, b) => compareString(a, b))
    .reduce<DeviceEvent[]>((result, date) => {
      const currentItems = dateMap[date];

      if (lastValue === null) {
        // Первый день - просто сортируем по value
        currentItems.sort((a, b) => compareString(a.date, b.date));
      } else {
        // Сортируем так, чтобы значения, совпадающие с lastValue, шли первыми
        currentItems.sort((a, b) => {
          // Сначала проверяем совпадение с lastValue
          if (a.companyId === lastValue && b.companyId !== lastValue) return -1;
          if (a.companyId !== lastValue && b.companyId === lastValue) return 1;
          // Если оба совпадают или оба не совпадают - сортируем по value
          return compareString(a.companyId, b.companyId);
        });
      }

      // Обновляем lastValue последним значением в этом дне
      lastValue = currentItems[currentItems.length - 1].companyId;

      return [...result, ...currentItems];
    }, []);
};
